import styled from 'styled-components'

export const HeaderBar = styled.div`
  display: none;
`

export const HeaderTitle = styled.span`
  display: none;
`

export const HeaderSealWrapper = styled.div`
  display: none;
`
